module.exports = __webpack_public_path__ + "static/media/importar.719291da.svg";